<template>
    <div class="form-item" v-show="item.visible">
        <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
            <div slot="content">
                {{item.description}}
            </div>
            <img class="form-tooltip" :src="require('@/assets/question.png')"/>
        </el-tooltip>
        <el-form-item :label="item.label" :rules="rules" :prop="item.prop">
            <el-input type='textarea' v-model="itemdata && result.address" :rows="3"  disabled :placeholder="item.prompt"></el-input>
        </el-form-item>
        <!--<el-form-item label="gpsopen">-->
            <!--<el-switch-->
                <!--v-model="gpsopen"-->
                <!--:disabled="$route.params.action ? !editable : !item.editable"-->
                <!--active-color="#13ce66"-->
                <!--inactive-color="#ff4949">-->
            <!--</el-switch>-->
        <!--</el-form-item>-->
    </div>
</template>


<script>
	import utils from '@/utils'
	import callApp from '@/services/sdk'
	export default {
		name: 'gps-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object },
			value: [Object, String]
		},
		data() {
			return {
				rules: utils.generateFormRule(this.item),
        gpsopen: false,
        result: {
        }
			}
		},
		computed: {
			itemdata: {
				get() {
					if (this.value && this.value.address) {
						this.result = { ...this.value }
          }
					return (this.value && this.value.address) || ""
        },
				set(itemdata) {
					this.$emit('input', Object.assign(this.result))
				}
			}
		},
    // watch: {
			// 'gpsopen': function (a, b) {
			// 	this.$emit('input', Object.assign(this.result, {gpsopen: this.gpsopen}))
			// }
    // },
		mounted() {
			window['web.getGps'] = () => {
				callApp('getGPS', {
					type: 'dataSource.gps',
					data: {}
				}, 'cbGetGPS').then(data => {
					if (data.gps) {
						this.result = { ...data.gps }
						this.$nextTick(_ => {
							this.itemdata = data.gps.address || ''
						})
					}
				})
			}
			!this.itemdata && this.callApp()
		},
    methods: {
			callApp() {
				callApp('getGPS', {
					type: 'dataSource.gps',
					data: {}
				}, 'cbGetGPS')
					.then(data => {
						if (data.gps) {
							this.result = { ...data.gps }
							this.$nextTick(_ => {
								this.itemdata = data.gps.address || ''
							})
            }
					})
			}
    }
	}
</script>

